var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 7.5,
    fill: "#F14E1A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23292 7.49994L11.348 10.6151C11.5507 10.8178 11.5507 11.1454 11.348 11.348C11.1453 11.5507 10.8177 11.5507 10.6151 11.348L7.49995 8.23283L4.38491 11.348C4.18219 11.5507 3.85467 11.5507 3.65204 11.348C3.44932 11.1454 3.44932 10.8178 3.65204 10.6151L6.76708 7.49994L3.65204 4.38474C3.44932 4.18211 3.44932 3.85449 3.65204 3.65185C3.75302 3.55078 3.8858 3.5 4.01848 3.5C4.15116 3.5 4.28384 3.55078 4.38491 3.65185L7.49995 6.76705L10.6151 3.65185C10.7162 3.55078 10.8488 3.5 10.9815 3.5C11.1142 3.5 11.2469 3.55078 11.348 3.65185C11.5507 3.85449 11.5507 4.18211 11.348 4.38474L8.23292 7.49994Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.1c9a4aaf49089cc2da7cb0f8b8240777.svg";
export { ForwardRef as ReactComponent };